import * as _4 from 'lodash4';
import { Strategy } from 'utility-ts-strategy';
import {
  ICheckboxQuestionMeta,
  IIntakeSurveyApiAnswer,
  IRadioQuestionMeta
} from '../builders/ap_intake_survey_builder';
import { IInTakeSurveyQuestionChoice } from '../builders/ap_intake_survey_question_choice_builder';

const radioQuestionAnswerMapping = (question: IRadioQuestionMeta) => ({
  value: question._answer['nk']
});

const checkboxQuestionAnswerMapping = (question: ICheckboxQuestionMeta): IIntakeSurveyApiAnswer[] =>
  question._answer.map((choice: IInTakeSurveyQuestionChoice) => ({ value: choice['nk'] }));

export const IntakeSurveyApiQuesAnswerStrategy = new Strategy({
  radio: radioQuestionAnswerMapping,
  checkbox: checkboxQuestionAnswerMapping
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/preferences/components/intake_survey/strategies/intake_survey_api_ques_ans_strategy.ts